import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const pendingRequests: any = {};

const getRequestKey = (config: { method: string; url: string }) =>
  `${config.method}-${config.url}`;

apiClient.interceptors.request.use(
  (config: AxiosRequestConfig | any) => {
    const local = localStorage.getItem('auth');
    const requestKey = getRequestKey(config);
    

    if (pendingRequests[requestKey]) {
      return Promise.reject(new axios.Cancel('REQUEST_ALREADY_IN_PROGRESS'));
    }

    pendingRequests[requestKey] = true;

    if (local && local != 'null') {
      const parsedAuth = JSON.parse(local);
      const token = parsedAuth.authorization;
      config.headers['Authorization'] = `${token?.type} ${token?.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    const requestKey = getRequestKey(response.config as any);
    delete pendingRequests[requestKey];
    return response.data;
  },
  (error) => {
    if (!axios.isCancel(error)) {
      const requestKey = getRequestKey(error.config || {});
      delete pendingRequests[requestKey];
      if (error.response && error.response.status === 401 && 
          !error.config?.url?.includes('/api/login')) {
        localStorage.removeItem('auth');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
